import { useEffect } from "react";
import "./prodSalidas.css";
import { useStoreSalidas } from "./useStoreSalidas";
import { MensajeError, useWindowDimensions } from "../../componentes/FuncionesLocales";
import { TabMenu } from "primereact/tabmenu";
import SalidasTab1 from "./SalidasTab1";
import SalidasTab2 from "./SalidasTab2";
import { useStoreLogin } from "../Login/useStoreLogin";
import { useStoreHome } from "../Home/useStoreHome";
import { useNavigate } from "react-router-dom";

const ProdSalidas = () => {
  // const registrosSalidas = useStoreSalidas((state) => state.registrosSalidas);
  const Fecha = useStoreSalidas((state) => state.Fecha);
  const TabSeleccionado = useStoreSalidas((state) => state.TabSeleccionado);
  const { width } = useWindowDimensions();
  const FechaCaducidad = useStoreHome((state) => state.FechaCaducidad);
  const navigate = useNavigate();

  useEffect(() => {
    if (!useStoreLogin.getState().validarVariablesGlobales()) {
      useStoreLogin.getState().logout();
    }
    useStoreSalidas.getState().getUnidades();
    useStoreSalidas.getState().getProcesos();
    useStoreSalidas.getState().getMercaderia();
    useStoreSalidas.getState().getBarrasGrillaPantalla();
    useStoreSalidas.getState().getFechas();
    useStoreSalidas.getState().getLotes();
  }, []);

  useEffect(() => {
    if (FechaCaducidad) {
      if (FechaCaducidad < new Date()) {
        MensajeError(
          "La licencia de uso ha caducado. Contacte a soporte técnico.",
        );
        navigate("/home");
      }
    }
  }, [FechaCaducidad, navigate]);

  useEffect(() => {
    useStoreSalidas.getState().getBarrasGrillaPantalla();
    useStoreSalidas.getState().getLotes(Fecha);
  }, [Fecha]);

  const items = [
    { label: "Proceso Productivo", icon: "pi pi-box" },
    { label: "Detalles", icon: "pi pi-list" },
  ];

  return (
    <div className="produccion-salidas ">
      <div
        className="container-titulo"
        style={{
          backgroundColor: "#00CC5B",
          padding: "12px 16px",
          borderRadius: "8px",
          color: "#fff",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
        }}
      >
        <span className="modulo-icono" aria-hidden="true"><i className="pi pi-arrow-circle-up" /></span>
        <div>
          <h2
            className="titulo"
            style={{
              color: "#f4f4f4ff",
              textShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            }}
          >
            Producción Salidas
          </h2>
          <p
            className="titulo-parrafo"
            style={{
              color: "#f4f4f4ff",
              textShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            }}
          >
            Utiliza esta pantalla para registrar en el inventario tus productos
            fabricados
          </p>
        </div>

        <div className="btn-play" style={{ marginLeft: "auto" }}>
        </div>
      </div>

      {width < 768 ? (
        <div className="salidas-content-scroll">
          <TabMenu
            model={items}
            activeIndex={Number(TabSeleccionado)}
            onTabChange={(e) =>
              useStoreSalidas.setState({ TabSeleccionado: e.index })
            }
          />
          <div className="salidas-layout animado-entrada">
            <div className="formulario-container">
              {TabSeleccionado === 0 && <SalidasTab1 />}
              {TabSeleccionado === 1 && (
                <div className="resumen-registros animado-entrada">
                  <SalidasTab2 />
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="salidas-content-scroll">
          {" "}
          {/* ← faltaba en desktop */}
          <div className="salidas-layout animado-entrada">
            <div className="formulario-container">
              <SalidasTab1 />
              <div className="resumen-registros animado-entrada">
                <SalidasTab2 />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProdSalidas;
